import { Injectable } from '@angular/core';
import { ChatPersonsService } from 'common/chat-persons/chat-persons.service';
import { ChatPerson } from 'common/xislivechat/models/chat-person';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable({
  providedIn: 'root'
})
export class ChatPersonsStoreFactory {
  constructor(private _chatPersonsService: ChatPersonsService,
              private _dynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  public create(chatId) {
    if (!chatId) {
      throw new Error('Missing chatId');
    }
    const chatPersons = this._chatPersonsService.observeByChatId(chatId);
    return this._dynamicQueryStoreObservableFactory.create<ChatPerson>(chatPersons, ChatPerson.comparator);
  }
}
